import React from 'react';

const BreadCrumb = ({ activeSection }) => {
  const breadcrumbItems = [
    { name: 'Panel', href: '/admin/', icon: 'fa-tachometer-alt' },
    { name: 'Usuarios', href: '/admin/usuario/crear', icon: 'fa-users' },
    // { name: 'Configuración', href: '/admin/configuracion', icon: 'fa-cogs' }
  ];

  const getTabIcon = (sectionName) => {
    const item = breadcrumbItems.find(item => item.name === sectionName);
    return item ? item.icon : 'fa-circle';
  };

  return (
    <section className="section" style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
      <div className="container is-fluid" style={{ paddingLeft: 0 }}>
        <div className="card mb-4">
          <div className="card-content p-0">
            <div className="tabs is-boxed is-medium mb-0">
              <ul>
                {breadcrumbItems.map((item) => {
                  const isActive = activeSection === item.name;
                  
                  return (
                    <li key={item.name} className={isActive ? 'is-active' : ''}>
                      <a 
                        href={item.href}
                        className="has-text-weight-semibold"
                      >
                        <span className="icon is-small mr-2">
                          <i className={`fa ${item.icon}`}></i>
                        </span>
                        <span>{item.name}</span>
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BreadCrumb;